import { ItemType } from "app/pages/AgentPricing/actionTypes";

export interface RateFinderWidgetState {
    criteria: RateFinderCriteria, 
    result: RateFinderResult    
}

export interface RateFinderCriteria {
    itemType?: ItemType
    itemId?: string
    schoolId?: string      
}

export interface RateFinderFoundResult {
    status: RateFinderResultStatus.Found
    rate: string
}

export interface RateFinderEmptyResult {
    status: RateFinderResultStatus.Errored | 
            RateFinderResultStatus.Running | 
            RateFinderResultStatus.NotFound |
            RateFinderResultStatus.Partial |
            RateFinderResultStatus.Empty
}

export type RateFinderResult = 
    RateFinderFoundResult|RateFinderEmptyResult;

export enum RateFinderResultStatus {
    Empty,
    Running, 
    NotFound, 
    Found, 
    Partial,
    Errored
}